import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { disableBodyScrolling } from '@/utils/disableBodyScrolling';
import { formatMoney } from '@/utils/formatting';

@Component
export class PopularBuildOverlay extends ThemeComponent {
    @Prop product!: Shopify.Liquid.Product;
    @Prop selectedVariant!: Shopify.Liquid.Variant;
    @Prop({ default: window.scrollY }) scrollPosition!: number;

    @Ref() closePopularBuildOverlayButton!: HTMLElement[];
    @Ref() additionalProduct!: HTMLElement[];
    @Ref() popularBuildImage!: HTMLImageElement;
    @Ref() popularBuildTitle!: HTMLElement;
    @Ref({required: false}) popularBuildSubtitle!: HTMLElement;
    @Ref() popularBuildSubtotal!: HTMLElement;

    init() {

        // Give initial value for scrollPosition
        this.scrollPosition = window.scrollY;

        // Add visibility click event listeners
        this.addVisibilityEventListeners();

        // Handle additional product selection
        this.handleAdditionalProductSelection();
    }

    addVisibilityEventListeners() {
        const popularBuildTriggerButton = document.querySelector('[data-ref="popularBuildTriggerButton"]');
        if (popularBuildTriggerButton) {
            const popularBuildTriggerButtonElem = popularBuildTriggerButton as HTMLElement;
            this.$listen(popularBuildTriggerButtonElem, 'click', () => {
                this.classList.add('popular-build-overlay--active');
                document.body.classList.add('page-scrolled-up');
                document.body.classList.remove('page-scrolled-down');

                // Disable body scrolling
                this.scrollPosition = disableBodyScrolling(true, this.scrollPosition);
            });
        }
        for (const button of this.closePopularBuildOverlayButton) {
            this.$listen(button, 'click', () => {
                this.classList.remove('popular-build-overlay--active');

                // Enable body scrolling
                this.scrollPosition = disableBodyScrolling(false, this.scrollPosition);
            });
        }
    }

    handleAdditionalProductSelection() {
        for (const additionalProduct of this.additionalProduct) {
            this.$listen(additionalProduct, 'click', () => {

                // Toggle selected class
                for (const otherAdditionalProduct of this.additionalProduct) {
                    additionalProduct.classList.add('popular-build-overlay-additional-products-item--selected');
                    if (otherAdditionalProduct !== additionalProduct) {
                        // eslint-disable-next-line max-len
                        otherAdditionalProduct.classList.remove('popular-build-overlay-additional-products-item--selected');
                    }
                }

                // Update image
                const variantImageAttribute = additionalProduct.getAttribute('data-image');
                if (variantImageAttribute) {
                    this.popularBuildImage.src = variantImageAttribute;
                }

                // Update title
                const variantTitleAttribute = additionalProduct.getAttribute('data-title');
                if (variantTitleAttribute) {
                    this.popularBuildTitle.innerHTML = variantTitleAttribute;
                }

                // Update subtitle
                if (this.popularBuildSubtitle) {
                    const variantSubtitleAttribute = additionalProduct.getAttribute('data-subtitle');
                    if (variantSubtitleAttribute) {
                        this.popularBuildSubtitle.innerHTML = variantSubtitleAttribute;
                    }
                }

                // Update subtotal
                const variantPriceAttribute = additionalProduct.getAttribute('data-variant-price');
                if (variantPriceAttribute) {
                    const variantPrice = parseInt(variantPriceAttribute, 10);
                    this.popularBuildSubtotal.innerHTML = formatMoney(variantPrice);
                }
            });
        }
    }
}
